export interface ISigningAppointmentScanbackManifest {
  totalDocuments: number;
  documentsReceived: number;
}

export const getDocsReceivedPercentage = (manifest: ISigningAppointmentScanbackManifest): number => {
  if(manifest.totalDocuments === 0){
    return 0;
  }
  return Math.floor((manifest.documentsReceived / manifest.totalDocuments) * 100);
}